export const WAREHOUSES_LIST_KEY = 'WAREHOUSES_LIST';
export const WAREHOUSES_ONE_KEY = 'WAREHOUSES_ONE_KEY';
export const WAREHOUSES_SUPPLIER_LIST_KEY = 'WAREHOUSES_SUPPLIER_LIST_KEY';
export const SUPPLIERS_PROVIDER_SUPPLIER_LIST_KEY = 'WAREHOUSES_SUPPLIER_LIST_KEY';

export const WAREHOUSE_SUPPLIER_AVAILABLE_LIST_KEY = 'WAREHOUSE_SUPPLIER_AVAILABLE_LIST_KEY';

export const WAREHOUSE_PRODUCTS_STOCK = 'WAREHOUSE_PRODUCTS_STOCK';

export const WAREHOUSE_USERS_KEY = 'WAREHOUSE_USERS_KEY';
